module.exports = __webpack_public_path__ + "static/media/hero.6c2c19af.jpg";